import React from "react";

/**
 * Subtle perspective grid background with radial fade — used behind sections.
 * Decorative only.
 */
export const GlowingGridBackground = ({
    accent = "#8B5CF6",
    opacity = 0.18,
    className = "",
}) => {
    return (
        <div
            aria-hidden="true"
            className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
            style={{ opacity }}
        >
            <div
                className="absolute inset-0"
                style={{
                    backgroundImage: `
            linear-gradient(${accent}50 1px, transparent 1px),
            linear-gradient(90deg, ${accent}50 1px, transparent 1px)
          `,
                    backgroundSize: "60px 60px",
                    maskImage:
                        "radial-gradient(ellipse 70% 60% at 50% 40%, #000 30%, transparent 80%)",
                    WebkitMaskImage:
                        "radial-gradient(ellipse 70% 60% at 50% 40%, #000 30%, transparent 80%)",
                }}
            />
        </div>
    );
};

export default GlowingGridBackground;
